<template>
  <div
    class="relative"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    @keydown.left="$emit('play')"
  >
    <!-- Volume: {{ volume }}
    <button class="btn btn-primary" @click="forceSetVolume(0.1)">0.1</button>
    <button class="btn btn-primary" @click="forceSetVolume(0.5)">0.5</button>
    <button class="btn btn-primary" @click="forceSetVolume(1)">1</button>
    <button class="btn btn-primary" @click="setMuted(true)">muted</button>
    <button class="btn btn-primary" @click="setMuted(false)">unmuted</button> -->

    <div class="relative" ref="videoWrapper">
      <audio
        :ref="uuid"
        class="w-full"
        controlsList="nodownload"
        :loop="loop"
        :autoplay="autoplay"
        :muted="autoplay"
        @timeupdate="($event) => $emit('timeupdate', $event.target)"
        @pause="$emit('isPlaying', false)"
        @play="$emit('isPlaying', true)"
        @click="$emit('play')"
      >
        <!-- <source :src="src" type="audio/mpeg" /> -->
        <source :src="src" :type="computedType" />
      </audio>

      <div
        v-if="controls"
        :class="{
          'opacity-0 translate-y-full': !hoverable && hovered,
          'opacity-0 translate-y-full': hoverable && !hovered
        }"
        class="px-14 bottom-0 left-0 w-full transition duration-300 transform"
      >
        <div
          class="w-full bg-black bg-opacity-30 px-5 py-4 rounded-xl flex items-center justify-between"
          @mouseleave="volume = false"
        >
          <div
            class="py-1 px-2 text-white rounded-md text-xs mr-5 whitespace-nowrap font-medium w-32 text-center"
            :style="`font-size: 11px; background-color: ${color}`"
          >
            {{ time.display }}&nbsp;/&nbsp;{{ duration }}
          </div>
          <div class="mr-5">
            <aw-icon
              v-show="playing"
              @click="$emit('play')"
              icon="pause"
              class="w-4 h-4 cursor-pointer text-white hover:text-bc-blue transition duration-300"
            />
            <aw-icon
              v-show="!playing"
              @click="$emit('play')"
              icon="play"
              class="w-4 h-4 cursor-pointer text-white hover:text-bc-blue transition duration-300"
            />
          </div>
          <div
            class="hidden lg:block w-full h-1 bg-white bg-opacity-40 rounded-sm cursor-pointer mr-6"
            @click="(e) => $emit('position', e)"
          >
            <div
              class="w-full rounded-sm h-full bg-white pointer-events-none"
              :style="`width: ${time.progress}%; transition: width .2s ease-in-out;`"
            />
          </div>
          <div class="relative mr-6">
            <div
              class="volumeControls w-128 origin-left translate-x-2 -rotate-90 w-128 transition duration-200 absolute transform top-0 py-2"
              :class="volume ? '-translate-y-4' : 'opacity-0 -translate-y-1 pointer-events-none'"
            >
              <div
                class="px-3 py-3 rounded-xl flex items-center transform translate-x-9 bg-black"
              >
                <input
                  v-model="amount"
                  @input="setVolume()"
                  type="range"
                  step="0.05"
                  min="0"
                  max="1"
                  class="rounded-lg overflow-hidden appearance-none bg-white bg-opacity-30 h-1.5 w-128 vertical-range"
                />
              </div>
            </div>
            <!-- <img
              :src="`/assets/video/volume_${Math.ceil(amount * 2)}.svg`"
              alt="High volume video"
              class="w-5 cursor-pointer filter-white transition duration-300 relative"
              style="z-index: 2"
              @click="stopVolume"
              @mouseenter="volume = true"
            /> -->

            <aw-icon
              :icon="`volume-${Math.ceil(amount * 2)}`"
              @click="stopVolume"
              @mouseenter="volume = true"
              class="w-5 h-5 cursor-pointer text-white hover:text-bc-blue transition duration-300"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!autoplay && mask && time.current === 0"
        :class="`transition transform duration-300 absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-filter z-10 flex items-center justify-center ${
          playing ? 'opacity-0 pointer-events-none' : ''
        }`"
      >
        <div
          class="w-20 h-20 rounded-full bg-white bg-opacity-20 transition duration-200 hover:bg-opacity-40 flex items-center justify-center cursor-pointer"
          @click="$emit('play')"
        >
          <img
            src="/assets/video/play.svg"
            alt="Icon play video"
            class="transform translate-x-0.5 w-12"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicTheme', // vue component name
  props: {
    ext: {
      type: String,
      required: true
    },
    uuid: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      required: false
    },
    autoplay: {
      type: Boolean,
      required: true
    },
    loop: {
      type: Boolean,
      required: true
    },
    controls: {
      type: Boolean,
      required: true
    },
    hoverable: {
      type: Boolean,
      required: true
    },
    mask: {
      type: Boolean,
      required: true
    },
    colors: {
      type: [String, Array],
      required: true
    },
    time: {
      type: Object,
      required: true
    },
    playing: {
      type: Boolean,
      default: false
    },
    duration: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      hovered: false,
      volume: false,
      amount: 1
    }
  },
  computed: {
    computedType() {
      const types = {
        mp3: 'audio/mpeg',
        ogg: 'audio/ogg',
        wav: 'audio/wav',
        flac: 'audio/flac',
      }

      return types[this.ext] ?? 'audio/mpeg'
    },
    color() {
      if (typeof this.colors === 'string') {
        return this.colors ? this.colors : '#8B5CF6'
      }
      return this.colors?.[0] ? this.colors[0] : '#8B5CF6'
    }
  },
  watch: {
    src() {
      this.$emit('isPlaying', false)
      this.$refs[this.uuid].load()
    }
  },
  mounted() {
    this.$emit('setPlayer', this.$refs[this.uuid])

    setTimeout(() => {
      this.$refs[this.uuid].style.height =
        this.$refs['videoWrapper'].offsetHeight + 'px'
    }, 0)
  },
  methods: {
    setVolume() {
      this.$refs[this.uuid].volume = this.amount
    },
    forceSetVolume(amount) {
      this.$refs[this.uuid].volume = amount
    },
    setMuted(state) {
      this.$refs[this.uuid].muted = state
    },
    stopVolume() {
      if (this.amount > 0) {
        this.setMuted(true)
        return (this.amount = 0)
      }
      this.setMuted(false)
      return (this.amount = 1)
    }
  }
}
</script>
